
const m = window.require("@ember/application/namespace");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
